import { useInfiniteQuery } from "@tanstack/react-query";
import { contactApi } from "../../api/contact";
import { GetContactPayload } from "../../types";

export const useGetContacts = (payload: Omit<GetContactPayload, "pageIndex" | "pageSize">) => {
  return useInfiniteQuery({
    queryKey: ["get-contacts", payload.keyword],
    queryFn: async ({ pageParam = 1 }) => {
      return contactApi.getContacts({
        ...payload,
        pageIndex: pageParam - 1,
        pageSize: 20,
      });
    },
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.reduce((acc, page) => acc + page.Data.length, 0);
      return loadedCount < lastPage.TotalRecord ? allPages.length + 1 : undefined;
    },
  });
};
